import { isNil, reject } from 'ramda'

// Refer to src/components/AddressAutocomplete/AddressAutocomplete.js
// Where the address string is formed

export const composeVariables = (values = {}, shouldSkipAddress = false) => {
  if (!values?.address) return false
  const addressSplit = values.address.split(', ')
  const hasLine2 = addressSplit?.length > 4

  if (!shouldSkipAddress && (!addressSplit?.length || addressSplit.length < 4))
    return false

  const address_1 = addressSplit[0]
  const address_2 = hasLine2 ? addressSplit[1] : false
  const city = hasLine2 ? addressSplit[2] : addressSplit[1]
  const state = hasLine2 ? addressSplit[3] : addressSplit[2]
  const zip = hasLine2 ? addressSplit[4] : addressSplit[3]

  const phones = values.phone_numbers?.map(({ phone }) => phone)
  const primaryPhone = values.phone_numbers?.find(
    ({ primary }) => primary
  )?.phone

  return {
    name: values.name,
    ...(!shouldSkipAddress && {
      address: {
        address_1,
        ...(hasLine2 && { address_2 }),
        city,
        state,
        zip
      }
    }),
    confidence: values.confidence,
    phone_numbers: phones,
    rightway_primary_phone: primaryPhone ?? null,
    location_types: reject(isNil, values.location_types)
  }
}

export const validateUniquePhone = (form, value) => {
  const allPhones = form.getFieldValue('phone_numbers') || []

  const duplicates = allPhones.filter(({ phone }) => phone === value)

  if (duplicates.length > 1) {
    return Promise.reject(new Error('Phone number must be unique'))
  }

  return Promise.resolve()
}
